import type { AgeGroupWithPrice } from "@/components/ProductCard"
import useCapacities from "@/queries/hooks/useCapacities"
import { useSkipassStore } from "@/store/skipassStore"

type UseRemainingCapacityOptions = {
  capacityGroupId?: string
  ageGroups: AgeGroupWithPrice[]
}

const NO_CAPACITY_RESULT = {
  totalQuantityForCapacity: 0,
  remainingCapacity: undefined,
  quantityOnHand: undefined,
} as const

const useRemainingCapacity = ({
  capacityGroupId,
  ageGroups,
}: UseRemainingCapacityOptions) => {
  const productIds = ageGroups.map((ag) => ag.productId)

  const totalQuantityForCapacity = useSkipassStore((state) => {
    if (!capacityGroupId) return 0
    return state.selectedProducts.reduce((total, product) => {
      return productIds.includes(product.productPriceId)
        ? total + product.quantity
        : total
    }, 0)
  })

  const { data: capacities } = useCapacities({
    capacityGroupIds: capacityGroupId ? [capacityGroupId] : [],
  })

  if (!capacityGroupId) {
    return NO_CAPACITY_RESULT
  }

  const quantityOnHand = capacities?.find(
    (c) => c.id === capacityGroupId
  )?.quantityOnHand

  const remainingCapacity =
    quantityOnHand !== undefined
      ? Math.max(0, quantityOnHand - totalQuantityForCapacity)
      : undefined

  return {
    totalQuantityForCapacity,
    remainingCapacity,
    quantityOnHand,
  }
}

export default useRemainingCapacity
